<template>
     <div class="card mb-3" style="min-height: 90vh;">
        <div class="card-body row">
            <Loading v-if="showLoading" />
            <div class="col-12">
                <div class="row m-0" >
                    <div class="col-9" style="display: flex; align-items: center;">
                        <h3 class="ml-2 my-4"> اطلاعات کلی
                            {{ person.firstName }} {{ person.lastName || '-' }} </h3>
                        <span class="badge badge-warning"
                            v-if="statusList.find(item => item.value === person.status) && statusList.find(item => item.value === person.status).value == 0">{{
                                statusList.find(item => item.value === person.status).value2 }}</span>
                        <span class="badge badge-info"
                            v-if="statusList.find(item => item.value === person.status) && statusList.find(item => item.value === person.status).value == 1">{{
                                statusList.find(item => item.value === person.status).value2 }}</span>
                        <span class="badge badge-primary"
                            v-else-if="statusList.find(item => item.value === person.status) && statusList.find(item => item.value === person.status).value == 2 && (person.apiCalls[0].lastResult && person.apiCalls[0].lastResult != '')">{{
                                statusList.find(item => item.value === person.status).value2 }}</span>
                        <span class="badge badge-dark"
                            v-else-if="statusList.find(item => item.value === person.status) && statusList.find(item => item.value === person.status).value == 2">{{
                                statusList.find(item => item.value === person.status).value2 }}</span>
                        <span class="badge badge-success"
                            v-else-if="statusList.find(item => item.value === person.status) && statusList.find(item => item.value === person.status).value == 3">{{
                                statusList.find(item => item.value === person.status).value2 }}</span>
                        <span class="badge badge-danger " style="cursor: pointer"
                            data-toggle="modal" :data-target="`#modal1${person.id}`"
                            v-else-if="statusList.find(item => item.value === person.status) && statusList.find(item => item.value === person.status).value == 4">{{
                                statusList.find(item => item.value === person.status).value2 }}</span>
                          <span class="badge badge-info-light"
                            v-if="statusList.find(item => item.value === person.status) && statusList.find(item => item.value === person.status).value == 5">{{
                                statusList.find(item => item.value === person.status).value2 }}</span>
                            <span class="badge badge-pink"
                            v-if="statusList.find(item => item.value === person.status) && statusList.find(item => item.value === person.status).value == 6">{{
                                statusList.find(item => item.value === person.status).value2 }}</span>
                            <span class="badge badge-pill"
                            v-if="statusList.find(item => item.value === person.status) && statusList.find(item => item.value === person.status).value == 7">{{
                                statusList.find(item => item.value === person.status).value2 }}</span>
                      
                </div>
                    <div  class="col-3" v-if="person.status == 0 && $store.state.role == 'admin'" style="display:flex ; align-items: center; justify-content: end;">
                        <button v-on:click="approveUser()" class="btn btn-success px-3 py-2 mr-1">
                            <i class="ti-user"></i>
                            تایید کاربر
                        </button>
                        <button data-toggle="modal" :data-target="'#modal-description'" class="btn btn-danger px-3 py-2 mr-1">
                            <i class="ti-user"></i>
                             عدم تایید کاربر
                        </button>
                    </div>
                    <div class="col-3" v-if="person.status == 4" style="display:flex ; align-items: center; justify-content: end;">
                        <router-link class="nav-link p-0" target="_blank" :to="{name: 'organizationForeigners.update', params: {id: person.id} }">
                            <button  class="btn btn-danger py-2 mr-1">
                                <i class="ti-user"></i>
                                ویرایش کاربر
                            </button>
                        </router-link>
                    </div>
                    <div  class="col-3" v-if="person.status == 5 && $store.state.role == 'admin'" style="display:flex ; align-items: center; justify-content: end;">
                        <button  v-on:click="getFidaCode()" class="btn btn-primary px-3 py-2 mr-1">
                            دریافت مجدد کد فیدا
                        </button>
                    </div>
                </div>
                <div class="modal effect-scale col-md-12" :id="'modal-description'" aria-hidden="true">
                    <div class="modal-dialog modal-lg modal-dialog-centered" role="document">
                        <div class="modal-content modal-content-demo">
                            <div class="modal-header">
                                <h6>  لطفا توضیحات خود را وارد نمایید </h6>
                                <button aria-label="بستن" class="close" data-dismiss="modal" type="button"><span
                                        aria-hidden="true">×</span></button>
                            </div>
                            <div class="row m-0" style="display: flex;">
                                <form class="form-group col-12" style="margin-top: 16px;" v-on:submit.prevent="rejectUser" >
                                    <div class="form-group col-6" >
                                        <label> توضیحات </label>
                                        <input class="form-control" style="min-height: 100px;" v-model="description">
                                    </div>
                                    <div class="col-12" style="display: flex; justify-content: end;" >
                                        <button :disabled="!description" type="submit" class="btn btn-success w-25 my-4 px-3 py-2 mr-1">
                                            <i class="ti-tick text-white">تایید </i>
                                        </button>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="row m-0">
                    <div class="col-9">
                        <div class="row">
                            <div class="col-6 px-2 py-1 border-0">
                                <div class="table-responsive">
                                    <table class="table main-table-reference text-nowrap my-0">
                                        <tbody>
                                            <tr>
                                                <td class="bg-gray-100" width="40%"><b>
                                                        نام</b></td>
                                                <td><b>{{ person.firstName || "-" }}</b></td>
                                            </tr>
                                            <tr>
                                                <td class="bg-gray-100"><b>
                                                        نام خانوادگی </b></td>
                                                <td> <b>
                                                        {{ person.lastName || "-" }}
                                                    </b></td>
                                            </tr>
                                            <tr>
                                                <td class="bg-gray-100"><b>
                                                        جنسیت </b></td>
                                                <td><b>
                                                        {{ person.genderId === 1 ? "مرد" : "زن"
                                                            || "-" }}
                                                    </b> </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                            <div class="col-6 px-2  py-1 border-0">
                                <div class="table-responsive">
                                    <table class="table main-table-reference text-nowrap my-0">
                                        <tbody>
                                            <tr>
                                                <td class="bg-gray-100" width="40%"><b> نام اجداد
                                                    </b></td>
                                                <td><b>
                                                        {{ person.ancestorName || "-" }}
                                                    </b> </td>
                                            </tr>
                                            <tr>
                                                <td class="bg-gray-100"><b> نام پدر </b>
                                                </td>
                                                <td><b>
                                                        {{ person.fatherName || "-" }}
                                                    </b>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td class="bg-gray-100"><b>
                                                        نام مادر </b></td>
                                                <td>
                                                    <b>
                                                        {{ person.motherName || "-" }}
                                                    </b>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                            <div class="col-6 px-2  border-0 py-1">
                                <div class="table-responsive">
                                    <table class="table main-table-reference text-nowrap my-0">
                                        <tbody>
                                            <tr>
                                                <td class="bg-gray-100" width="40%"><b>
                                                        ملیت </b></td>
                                                <td><b v-if="person.nationality">
                                                        {{ person.nationality.title }}
                                                    </b>
                                                    <b v-else>-</b>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td class="bg-gray-100"><b> کشور محل تولد </b>
                                                </td>
                                                <td>
                                                    <b v-if="person.birthPlaceCountry">
                                                        {{ person.birthPlaceCountry.title }}
                                                    </b>
                                                    <b v-else>-</b>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td class="bg-gray-100"><b>
                                                        شهر محل تولد</b></td>
                                                <td> <b>
                                                        {{ person.cityOfBirth || "-" }}
                                                    </b></td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                            <div class="col-6 px-2  border-0 py-1">
                                <div class="table-responsive">
                                    <table class="table main-table-reference text-nowrap my-0">
                                        <tbody>
                                            <tr>
                                                <td class="bg-gray-100" width="40%">
                                                    <b> وضعیت تاهل </b>
                                                </td>
                                                <td>
                                                    <b>
                                                        {{ person.maritalStatusId === 1 ? "مجرد"
                                                            :
                                                            "متاهل" || "-" }} </b>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td class="bg-gray-100">
                                                    <b> تاریخ تولد </b>
                                                </td>
                                                <td><b v-if="person.birthDate">
                                                        {{person.birthDate.replace(/-/g,'/')}}
                                                    </b>
                                                    <b v-else>
                                                        -
                                                    </b>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td class="bg-gray-100" width="40%">
                                                    <b> ثبت کننده </b>
                                                </td>
                                                <td><b v-if="person.consumer">
                                                    {{person.consumer.title }}
                                                    </b>
                                                    <b v-else> - </b>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>

                            <div class="col-6 px-2  border-0 py-1">
                                <div class="table-responsive">
                                    <table class="table main-table-reference text-nowrap my-0">
                                        <tbody>
                                            <tr>
                                                <td class="bg-gray-100" width="40%">
                                                    <b> شماره همراه </b>
                                                </td>
                                                <td>
                                                    <b> {{ person.mobileNumber || "-" }} </b>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td class="bg-gray-100">
                                                    <b> شماره کارت </b>
                                                </td>
                                                <td><b v-if="person.cards">
                                                        {{person.cards.cardNumber}}
                                                    </b>
                                                    <b v-else>
                                                        -
                                                    </b>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td class="bg-gray-100" width="40%">
                                                    <b>  وضعیت کارت </b>
                                                </td>
                                                <td><b v-if="person.cards">
                                                        {{person.cards.status}}
                                                    </b>
                                                    <b v-else>
                                                        -
                                                    </b>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>

                            <div v-for="(document, index) in documents" :key="index" class="col-6 px-2  border-0 py-1">
                                <div v-if="document.title" class="table-responsive">

                                    <table class="table main-table-reference text-nowrap my-0">
                                        <tbody>
                                            <tr>
                                                <td class="bg-gray-100" width="40%">
                                                    <b> نوع مدرک </b>
                                                </td>
                                                <td><b >
                                                        {{document.title  || "-"}}
                                                    </b>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td class="bg-gray-100">
                                                    <b> شماره {{ document.title }} </b>
                                                </td>
                                                <td> <b >
                                                        {{ document.documentNumber || "-" }}
                                                    </b>
                                                
                                                </td>
                                            </tr>
                                            <tr>
                                                <td class="bg-gray-100"><b> تاریخ اعتبار {{document.title   }} </b>
                                                </td>
                                                <td>
                                                    <span>از </span>
                                                    <b >  {{ document.issueDate || "-" }}</b>
                                                    <span> تا </span>
                                                    <b >  {{ document.expirationDate || "-" }}</b>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td class="bg-gray-100"><b> تصاویر {{document.title   }} </b>
                                                </td>
                                                <td style="height: 55px;" >
                                                    <b v-for="(photo, index) in document.photos" :key="index" >
                                                        <button class="btn btn-primary ml-2" @click="e => downloadFile(e,photo)" >
                                                            <i class="ti-download m-1 "> </i> تصویر  {{ index +1 }}  
                                                        </button>
                                                    
                                                    </b>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-3">
                        <div class="row">
                            <div class="col-12" style="display: flex; min-height: 250px ; align-items: center; justify-content: center;" >
                                <img  v-if="person.photoBase64" class="ht-200" alt="user" :src="'data:image/png;base64,'+person.photoBase64" ><img/>
                            </div>
                            <div class="col-12 px-2 py-1 border-0">
                                 <div class="row" style="display: flex; align-items: center; justify-content:space-between;" >
                                     <span class="mr-2" style="font-weight: 500;">
                                         شماره رفرنس :
                                     </span>
                                     <span class="mx-2" >
                                         {{ person.referenceNumber || " " }}
                                     </span>
                                     <button v-if="person.referenceNumber" class="btn btn-icon" v-on:click="copyToClipBoard(person.referenceNumber)" >
                                             <i class="ti-files text-dark"> </i>  
                                     </button>
                                 </div>
                            </div>
                             <div class="col-12 px-2 py-1 border-0">
                                <div class="row" style="display: flex; align-items: center; justify-content:space-between;" >
                                    <span class="mr-2" style="font-weight: 500;">
                                       کد پیگیری:
                                    </span>
                                    <span class="mx-2" >
                                        {{ person.trackingCode || " " }}
                                    </span>
                                    <button v-if="person.trackingCode" class="btn btn-icon" v-on:click="copyToClipBoard(person.trackingCode)" >
                                            <i class="ti-files text-dark"> </i>  
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div v-if="person.status==4 && person.description" class="col-12">
                    <i  class="ti-alert" style="color: red; height: 2px;"></i>
                    <span style="color: red; height: 2px;" >{{ person.description }}</span>
                </div>
            </div>
        </div>
    </div>
</template>


<script>

export default {
    name: 'View',
    data() {
        return {
            person : {} ,
            statusList:[],
            documents:[],
            identificationDocumentTypes:[],
            description:null,
            showLoading:true,
            dialog: false,
        }
    },
    methods: {
        async getFidaCode(){
            this.showLoading = true;
            this.$api.post('Organizations/Fida/Person/AddToGetReferenceCodeRequeue', {
                "authorizationToken": localStorage.getItem('agc-token'),
                "personId" : parseInt(this.$route.params.id),
              }).then(() => {
                this.$swal({
                    title: 'تبریک',
                    icon: 'success',
                    text: 'درخواست با موفقیت ایجاد شد'
                })
            });
            this.showLoading = false;
        },
         downloadFile(e,photoId){
            e.preventDefault();
            this.$api.post('Organizations/Fida/Person/GetPhoto',{photoId ,  "authorizationToken": localStorage.getItem('agc-token'), }).then(({data}) => {
                let a = window.document.createElement('a');
                a.setAttribute('href',"data:image/png;base64," +  data.result.photoBase64);
                a.setAttribute('download',"image.png");
                window.document.body.appendChild(a);
                a.click();
                window.document.body.removeChild(a);
            });
        },
        copyToClipBoard(value){
            if (navigator.clipboard){
                navigator.clipboard.writeText(value).then(
                    function(){
                        alert("کپی شد"); // success 
                    })
                .catch(
                    function() {
                        alert("err"); // error
                });
            } 
        },
        async rejectUser(){
           this.showLoading = true;
            this.$api.post('Organizations/Fida/Person/Reject', {
                "authorizationToken": localStorage.getItem('agc-token'),
                "personId" : parseInt(this.$route.params.id),
                "description" : this.description,
              }).then(({data}) => {
                  if (data.status) {
                    location.reload(); 
                }
            }).catch(()=>{
                this.$swal({
                    title: 'ناموفق',
                    icon: 'error',
                    text: 'مجددا اقدام کنید!'
                })
            });
            this.showLoading = false;
        },
        async approveUser(){
            this.$dialog
                .confirm('آیا از درخواست خود اطمینان دارید ؟ ')
                .then((dialog) => {
                    this.showLoading = true;
                    this.$api.post('Organizations/Fida/Person/Approve', {
                        "authorizationToken": localStorage.getItem('agc-token'),
                        "personId" : parseInt(this.$route.params.id),
                    }).then(({data}) => {
                        if (data.status) {
                            location.reload(); 
                        }
                    }).catch(()=>{
                        this.$swal({
                            title: 'ناموفق',
                            icon: 'error',
                            text: 'مجددا اقدام کنید!'
                        })
                    }).finally(() => {
                        this.showLoading = false;
                        if (dialog) { dialog.close() }
                    })
            })
            
        },
        async getInitialData(){
            this.showLoading = true;
            this.$api.get('Organizations/Fida/LookUp/GetIdentificationDocumentTypeIds').then(({ data }) => {
                if (data.status) {
                    this.identificationDocumentTypes = data.result;
                }
            }).finally(() => {
                this.showLoading = false;
            });
              this.$api.get('Organizations/Fida/LookUp/GetStatusList').then(({ data }) => {
                if (data.status) {
                    this.statusList = data.result;
                    this.showLoading = false;
                }
            });
        },
        async getData() {
            this.showLoading = true;
            const body = {
                "authorizationToken": localStorage.getItem('agc-token'),
                "personId" : parseInt(this.$route.params.id)
            }
            this.$api.post('Organizations/Fida/Person/Get', body).then(({ data }) => {
                if (data.status) {
                    this.showLoading = false;
                    this.person = data.result;
                }
                this.showLoading = false;
            }).catch(() => {
                this.showLoading = false;
                this.$swal({
                    title: 'ناموفق',
                    icon: 'error',
                    text: ' داده ای  یافت نشد ,لذا مجدد اقدام کنید!'
                })

            })
        },
    },
    watch:{
        person: function(value){
            if(value.documents && value.documents.length > 0 && this.identificationDocumentTypes.length > 0 && this.documents.length ===0 ){
                  console.log("here1");
                this.documents = value.documents.map(
                    (doc) =>{
                        const findItem = this.identificationDocumentTypes.find((type)=> type.value == doc.identificationDocumentTypeId)
                        if(findItem) return {...doc , title : findItem.title}
                        return doc
                    }
                )
            }
        },
        identificationDocumentTypes: function(value){
            if(value && value.length > 0 && this.person.documents && this.person.documents.length > 0 && this.documents.length ===0 ){
                this.documents = this.person.documents.map(
                    (doc) =>{
                        if(!doc) return {}
                        const findItem = value.find((type)=> type.value == doc.identificationDocumentTypeId)
                        if(findItem) return {...doc , title : findItem.title}
                        return doc
                    }
                )
            }
        }
    },
    created() {
        this.getInitialData();
        this.getData();
    }
}
</script>